<template>
  <div>
    <div>
      <div class="card-header">
        <div class="row">
          <div class="col-md-11">
            <h4>Gestión de salarios en avanza</h4>
            <p>
              Aquí podrá gestionar la información relacionada con los
              <span class="text-success">salarios</span> fijos o variables de
              los empleados de <span class="text-success">Avanza</span>
            </p>
          </div>
        </div>
      </div>
      <br />
      <div class="card">
        <div class="row">
          <center>
            <div class="col-md-12" v-if="queriedData2 == ''">
              <center>
                <img
                  src="/static/img/ICONOS/estadisticas.svg"
                  alt="Imagen de datos vacios"
                  width="70"
                />
                <p class="titulo-mensaje">Aún no hay datos para mostrar.</p>
              </center>
            </div>
          </center>
        </div>
        <!-- add this -->
        <div class="row" style="padding-left: 15px" v-if="queriedData2 != ''">
          <div class="col-3">
            <el-select
              class="select-default"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>
        </div>
        <br />
        <div class="row" ref="component" v-if="queriedData2 != ''">
          <div class="col-md-12">
            <download-excel
              class="btn btn-secondary btn-fill mb-2"
              :data="json_data"
              :fields="json_fields"
              worksheet="Usuarios-salarios avanza"
              name="Salarios avanza"
              v-if="json_data != ''"
            >
              Exportar a excel <i color="black" class="fa fa-download"></i>
            </download-excel>
            <br />
          </div>
          <div class="col-md-12">
            <br />
            <el-table
              border
              :data="queriedData"
              class="table-responsive table-striped mt-2"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
                <template slot-scope="{ row }">
                  <div :class="getClass(column, row)" class="full-width">
                    <strong v-if="getClass(column, row) != ''">{{
                      row[column.prop]
                    }}</strong>
                    <strong v-else-if="column.tipo == 'COP'">
                      {{ formatearPesosColombianos(row[column.prop]) }}
                    </strong>
                    <span v-else>{{ row[column.prop] }}</span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column :min-width="40">
                <template slot-scope="props">
                  <center>
                    <button
                      class="btn btn-simple btn-info btn-icon like"
                      @click="modal(props.row)"
                    >
                      <i class="ti-pencil"></i>
                    </button>
                  </center>
                </template>
              </el-table-column>
            </el-table>

            <modal
              name="gestionar-salario"
              :scrollable="true"
              height="auto"
              :reset="true"
            >
              <div class="modal-header" style="padding: 8px">
                <div class="row">
                  <div class="col-md-12">
                    <strong class="titulo-modal">
                      GESTIONAR LA INFORMACIÓN DE CONTRATO Y SALARIO
                    </strong>
                    <br>
                    <span style="color:grey;">
                      Asignación y/o modifiación de contrato y salarios
                    </span>
                  </div>
                </div>
              </div>
              <div class="modal-body" v-if="usuarioSeleccionado.idUsuario != ''">
                <p>Ajustar el tipo de contrato y salario de: <strong> {{ usuarioSeleccionado.nombreUsuario }} </strong></p>
                <form @submit.prevent="actualizarInformacion()">
                    <div class="row">
                        <div class="col-md-12">
                            <label for="tipoContrato">Tipo de contrato:</label>
                            <select id="tipoContrato" v-model="usuarioSeleccionado.tipoContratoId" class="form-control">
                                <option value="1">Prestación de servicios</option>
                                <option value="2">Contrato indefinido</option>
                                <option value="3">Contrato termino fijo</option>
                            </select>
                        </div>
                        <div class="col-md-12">
                            <label for="salarioFijo">Salario fijo:</label>
                            <input type="text" id="salarioFijo" v-model="usuarioSeleccionado.salarioFijo"  title="Escribir salario sin puntos" class="form-control">
                        </div>
                        <div class="col-md-12">
                            <label for="transporte">Auxilio de transporte:</label>
                            <input type="text" id="transporte" v-model="usuarioSeleccionado.transporte"  title="Escribir salario sin puntos" class="form-control">
                        </div>
                        <div class="col-md-12">
                            <label for="salarioPorSesion">Pago por sesión:</label>
                            <input type="text" id="salarioPorSesion" v-model="usuarioSeleccionado.pagoPorSesion" title="Escribir salario sin puntos" class="form-control">
                        </div>
                        <div class="col-md-12">
                            <label for="salarioPorSesionParticular">Pago por sesión particular:</label>
                            <input type="text" id="salarioPorSesionParticular" v-model="usuarioSeleccionado.pagoPorSesionParticular" title="Escribir salario sin puntos" class="form-control">
                        </div>
                        <div class="col-md-12">
                            <label for="salarioPorSesionDomicilio">Pago por sesión domiciliaria:</label>
                            <input type="text" id="salarioPorSesionDomicilio" v-model="usuarioSeleccionado.pagoPorSesionDomicilio" title="Escribir salario sin puntos" class="form-control">
                        </div>
                        <div class="col-md-12">
                            <label for="salarioPorSesionDomicilioParticular">Pago por sesión domiciliaria particular:</label>
                            <input type="text" id="salarioPorSesionDomicilioParticular" v-model="usuarioSeleccionado.pagoPorSesionDomicilioParticular" title="Escribir salario sin puntos" class="form-control">
                        </div>
                        <div class="col-md-12">
                            <label for="salarioPorEvaluacion">Pago por evaluación:</label>
                            <input type="text" id="salarioPorEvaluacion" v-model="usuarioSeleccionado.pagoPorEvaluacion" title="Escribir salario sin puntos" class="form-control">
                        </div>
                        <div class="col-md-12">
                            <label for="salarioPorEvaluacionDomicilio">Pago por evaluación particular:</label>
                            <input type="text" id="salarioPorEvaluacionDomicilio" v-model="usuarioSeleccionado.pagoPorEvaluacionDomicilio" title="Escribir salario sin puntos" class="form-control">
                        </div>
                        <div class="col-md-12">
                            <label for="eps">Caja de compensación:</label>
                            <input type="text" id="eps" v-model="usuarioSeleccionado.eps" title="Escribir salario sin puntos" class="form-control">
                        </div>
                        <div class="col-md-12">
                            <label for="pension">Pensión:</label>
                            <input type="text" id="pension" v-model="usuarioSeleccionado.pension" title="Escribir salario sin puntos" class="form-control">
                        </div>
                        <div class="col-md-12">
                            <label for="arl">ARL:</label>
                            <input type="text" id="arl" v-model="usuarioSeleccionado.arl" title="Escribir salario sin puntos" class="form-control">
                        </div>
                        <div class="col-md-12">
                            <center>
                                <br>
                                <button class="btn btn-primary" type="button" @click="cerrarModal()">Cancelar</button>
                                <button type="submit" class="btn btn-success btn-fill">Actualizar datos</button>
                            </center>
                        </div>
                    </div>
                </form>
              </div>
            </modal>
          </div>
        </div>
        <!-- add this -->
        <div class="row" v-if="queriedData2 != ''">
          <div class="col-sm-6 pagination-info">
            <br />
            <p class="category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <div class="col-sm-6">
            <p-pagination
              class="pull-right"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
            ></p-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import axiosInstance from "src/global-services/axiosInstance";
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import JsonExcel from "vue-json-excel";
import crearAlerta from "../../global-services/crearAlerta";
import formatearPesosColombianos from "../../global-services/formatear-pesos";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
Vue.component("downloadExcel", JsonExcel);

export default {
  computed: {
    pagedData() {
      return this.queriedData2.slice(this.from, this.to);
    },
    queriedData() {
      if (!this.searchQuery) {
        this.pagination.total = this.queriedData2.length;
        return this.pagedData;
      }
      let result = this.queriedData2.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (
            rowValue.includes &&
            rowValue.includes(this.searchQuery.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.queriedData2.length;
      return this.queriedData2.length;
    },
  },
  data: () => ({
    searchQuery: "",
    fechaInicial: "",
    fechaFinal: "",
    queriedData2: [],
    fechaActual: "",
    tableColumns: [
      {
        prop: "nombreUsuario", 
        label: "usuario", 
        minWidth: 150,
        tipo : "text"
      },
      {
        prop: "salarioFijo", 
        label: "Salario fijo", 
        minWidth: 100,
        tipo: "COP"
      },
      {
        prop: "transporte", 
        label: "Aux. Transporte", 
        minWidth: 100,
        tipo: "COP"
      },
      {
        prop: "pagoPorSesion", 
        label: "Pago por sesión", 
        minWidth: 100,
        tipo: "COP"
      },
      {
        prop: "pagoPorSesionParticular", 
        label: "Pago por sesión particular", 
        minWidth: 100,
        tipo: "COP"
      },
      {
        prop: "pagoPorSesionDomicilio", 
        label: "Pago por sesión domicilio", 
        minWidth: 100,
        tipo: "COP"
      },
      {
        prop: "pagoPorSesionDomicilioParticular", 
        label: "Pago por sesión domicilio particular", 
        minWidth: 100,
        tipo: "COP"
      },
      {
        prop: "pagoPorEvaluacion", 
        label: "Pago por evaluación", 
        minWidth: 100,
        tipo: "COP"
      },
      {
        prop: "pagoPorEvaluacionDomicilio", 
        label: "Pago por evaluación particular", 
        minWidth: 100,
        tipo: "COP"
      },
      {
        prop: "eps", 
        label: "Caja de C", 
        minWidth: 100,
        tipo: "COP"
      },
      {
        prop: "pension", 
        label: "Pensión", 
        minWidth: 100,
        tipo: "COP"
      },
      {
        prop: "arl", 
        label: "ARL", 
        minWidth: 100,
        tipo: "COP"
      },
    ],
    json_fields: {
      "Usuario": "nombreUsuario",
      "Tipo de contrato": "tipoContrato",
      "Salario fijo": "salarioFijo",
      "Pago por sesión": "pagoPorSesion",
      "Pago por sesión particular": "pagoPorSesionParticular",
      "Pago por sesión domicilio": "pagoPorSesionDomicilio",
      "Pago por sesión domicilio particular": "pagoPorSesionDomicilioParticular",
      "Pago por evaluación" : "pagoPorEvaluacion",
      "Pago por evaluación particular" : "pagoPorEvaluacionDomicilio",
    },
    json_data: [],
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
    SedesProgramacion: [],
    sede: "Sede Principal",
    rol: "",
    tipo: "",
    usuarioSeleccionado: {
        nombreUsuario: "",
        tipoContrato: "",
        salarioFijo: "",
        pagoPorSesion: "",
        pagoPorSesionParticular: "",
        pagoPorSesionDomicilio: "",
        pagoPorSesionDomicilioParticular: "",
        pagoPorEvaluacion: "",
        pagoPorEvaluacionDomicilio: "",
        tipoContratoId: "",
        eps: "",
        pension: "",
        arl: "",
        transporte: "",
        idUsuario: ""
    },
    pagination: {
      perPage: 25,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50, 100, 200, 300],
      total: 0,
    },
  }),
  components: {
    PPagination,
  },
  methods: {
    formatearPesosColombianos,
    async obtenerInformacionSalarios() {
      try {
        this.$modal.show("carga");
        const sede = localStorage.getItem("sede");
        const response = await axiosInstance.get(
          `api/informe-salarios/${sede}`
        );
        this.queriedData2 = response.data.data;
        this.json_data = response.data.data;
      } catch (error) {
        console.log("Error al obtener los datos:" + error);
      } finally {
        this.$modal.hide("carga");
      }
    },
    async actualizarInformacion() {
      try {
        this.$modal.show("carga");
        const payload = this.usuarioSeleccionado;
        const response = await axiosInstance.post(`api/actualizar-informacion-salario`, payload);
        if(response.data.status == false){
          this.$notify(crearAlerta("danger", 'Error al actualizar la información'));
        }else{
          this.obtenerInformacionSalarios();
          this.cerrarModal();
          this.$notify(crearAlerta("success", 'Datos actualizados correctamente'));
        }
      } catch (error) {
        console.log("Error al actualizar la información:" + error);
        this.$notify(crearAlerta("danger", 'Error al actualizar la información'));
      } finally {
        this.$modal.hide("carga");
      }
    },
    modal: function (usuario) {
      this.usuarioSeleccionado.nombreUsuario = usuario.nombreUsuario;
      this.usuarioSeleccionado.tipoContrato = usuario.tipoContrato;
      this.usuarioSeleccionado.tipoContratoId = usuario.tipoContratoId;
      this.usuarioSeleccionado.salarioFijo = usuario.salarioFijo;
      this.usuarioSeleccionado.pagoPorSesion = usuario.pagoPorSesion;
      this.usuarioSeleccionado.pagoPorSesionParticular = usuario.pagoPorSesionParticular;
      this.usuarioSeleccionado.pagoPorSesionDomicilio = usuario.pagoPorSesionDomicilio;
      this.usuarioSeleccionado.pagoPorSesionDomicilioParticular = usuario.pagoPorSesionDomicilioParticular;
      this.usuarioSeleccionado.pagoPorEvaluacion = usuario.pagoPorEvaluacion;
      this.usuarioSeleccionado.pagoPorEvaluacionDomicilio = usuario.pagoPorEvaluacionDomicilio;
      this.usuarioSeleccionado.eps = usuario.eps;
      this.usuarioSeleccionado.pension = usuario.pension;
      this.usuarioSeleccionado.arl = usuario.arl;
      this.usuarioSeleccionado.transporte = usuario.transporte;
      this.usuarioSeleccionado.idUsuario = usuario.idUsuario;
      this.$modal.show("gestionar-salario");
    },
    cerrarModal: function (){
        this.usuarioSeleccionado.idUsuario = "";
        this.usuarioSeleccionado.tipoContrato = "";
        this.usuarioSeleccionado.tipoContratoId = "";
        this.usuarioSeleccionado.salarioFijo = "";
        this.usuarioSeleccionado.pagoPorSesion = "";
        this.usuarioSeleccionado.pagoPorSesionParticular = "";
        this.usuarioSeleccionado.pagoPorSesionDomicilio = "";
        this.usuarioSeleccionado.pagoPorSesionDomicilioParticular = "";
        this.usuarioSeleccionado.pagoPorEvaluacion = "";
        this.usuarioSeleccionado.pagoPorEvaluacionDomicilio = "";
        this.usuarioSeleccionado.eps = "";
        this.usuarioSeleccionado.pension = "";
        this.usuarioSeleccionado.arl = "";
        this.usuarioSeleccionado.transporte = "";
        this.usuarioSeleccionado.idUsuario = "";
        this.$modal.hide("gestionar-salario");
    },
    getClass(column, row) {
      if (column.prop === "tipoContrato") {
        return row.classContrato;
      }
      return "";
    },
  },
  mounted() {
    this.rol = localStorage.getItem("rol");
    if (localStorage.getItem("rol") != 1) {
      this.sede = localStorage.getItem("sede");
    }
    document.title = "Avanti | Gestión de salarios";
    this.obtenerInformacionSalarios();
  },
};
</script>
  
  <style>
.card {
  box-shadow: 0 0 0 0;
  border-radius: 15px;
  padding: 2%;
}

.btn {
  border-radius: 5px;
}

.high-percentage {
  background-color: #a0e2b3;
  /* color: white !important; */
}

.medium-percentage {
  background-color: #f2e3b0;
  /* color: black; */
}

.low-percentage {
  background-color: #fb817e;
  /* color: white; */
}

.full-width {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  /* padding: 15px; Si quieres mantener el padding interno */
}

.el-table__cell {
  height: 20px !important;
}
</style>
    


// WEBPACK FOOTER //
// src/components/ADashboard/salarios.vue